import { useState, useEffect } from "react";
import useAuth from "./useAuth";
import { useAlert } from "../context/AlertContext";
import {
  useUpdateMeMutation,
  useUpdateMyPasswordMutation,
} from "../store/authApi";

export const useProfileForm = () => {
  const [updateMe, resultUpdateMe] = useUpdateMeMutation();
  const [updateMyPassword, resultUpdateMyPassword] =
    useUpdateMyPasswordMutation();
  const { auth, setAuth } = useAuth();
  const { showSuccess, showError } = useAlert();

  const [userInfo, setUserInfo] = useState({
    name: auth?.name || "",
    lastName: auth?.lastName || "",
    email: auth?.email || "",
    tel: auth?.tel || "",
  });

  const [input, setInput] = useState({
    name: "",
    lastName: "",
    email: "",
    tel: "",
    password: "",
    passwordCurrent: "",
    passwordConfirm: "",
    id: "",
    token: "",
  });

  useEffect(() => {
    if (resultUpdateMe.isError) {
      showError(resultUpdateMe.error?.data?.message || "İşlem başarısız tekrar deneyin!");
    }
    if (resultUpdateMe.isSuccess) {
      showSuccess("Profil başarı ile güncellendi!");
      const user = resultUpdateMe?.data?.data?.user;
      setAuth({ ...user, accessToken: auth.accessToken });
      setUserInfo({
        name: user.name,
        lastName: user.lastName,
        email: user.email,
        tel: user.tel,
      });
    }
  }, [resultUpdateMe.isSuccess, resultUpdateMe.isError]);

  useEffect(() => {
    if (resultUpdateMyPassword.isError) {
      showError("İşlem başarısız tekrar deneyin!");
    }
    if (resultUpdateMyPassword.isSuccess) {
      showSuccess("Şifre başarı ile güncellendi!");
      const accessToken = resultUpdateMyPassword?.data?.token;
      const user = resultUpdateMyPassword?.data?.data?.user;
      setAuth(user ? { ...user, accessToken, mustChangePassword: false } : { ...auth, accessToken, mustChangePassword: false });
    }
  }, [resultUpdateMyPassword.isSuccess, resultUpdateMyPassword.isError]);

  return {
    updateMe,
    updateMyPassword,
    userInfo,
    setUserInfo,
    input,
    setInput,
    token: auth?.accessToken,
    auth,
    resultUpdateMe,
    resultUpdateMyPassword,
  };
};
